import { Component } from 'react';

class ColumnFilterHeader extends Component {
    render() {
        const {
            onCheckedOfColumnFilter,
            requestForId,
            tabsData,
            filterName,
            isFilter,
            columnFilters,
            filteredDataColumns
        } = this.props;

        const tabData = tabsData.find(x => x.Id === requestForId);
        let cols = [];
        let filter;

        const isShow = (columnFilters.find(x => x.eventName === filterName) === undefined) ? false:columnFilters.find(x => x.eventName === filterName).isStatus;

        const style = isShow ? '' : 'none';

        if (!isFilter) {
            cols = tabData.QueueViewGrid.Columns;
        } else {
            filter = tabData.QueueViewGrid.GridFilters.find(x => x.FilterName === filterName);
            cols = filter.FilterData;
        }

        if (tabData.AdvanceSearch !== null && tabData.AdvanceSearch !== undefined) {
            cols.forEach(col => {
                const filterData = tabData.AdvanceSearch.find(searchFilter =>
                    searchFilter.PropertyValue === col.Id
                    && searchFilter.PropertyName === filter.FilterName
                );
                col.IsFiltered = filterData !== undefined;
            });
        }

        const classNameOnFilterName = cols.length < 10 ? 'cn-filter__menu' : 'cn-filter__menu noc-filter__menu';
        const classNameOnUl = cols.length < 10 ? 'cn-filter__list' : 'cn-filter__list noc-filter__menu';

        return (
            <div
                className={classNameOnFilterName}
                style={{
                    display: style
                }}
                id={filterName}
            >
                <h4 className="cn-filter__hdr">{isFilter === true
                    ? <br />
                    : 'Display Options'}</h4>
                <div className="cn-filter__toolbar">
                    <p className="cn-filter__toggle">
                        Check:&nbsp;
                    <a
                        href="javascript:;"
                        className="cn-filter__toggle-link"
                        data-check-all
                        onClick={evt => {
                            evt.preventDefault();
                            onCheckedOfColumnFilter(tabsData, requestForId, 'All', false, isFilter, filterName, (isFilter
                                    ? filter.FilterId
                                    : 0));
                        }}
                    >All</a>
                        &nbsp;
                        <a
                            href="javascript:;"
                            className="cn-filter__toggle-link"
                            data-check-none
                            onClick={evt => {
                                evt.preventDefault();
                                onCheckedOfColumnFilter(tabsData, requestForId, 'None', true, isFilter, filterName, (isFilter
                                    ? filter.FilterId
                                    : 0));
                            }}
                        >None</a>
                    </p>
                </div>
                <ul className={classNameOnUl}>
                    {cols.map((header, i) => (
                        <li key={i}>
                            <label className="cn-field__opt noc-field__opt">
                                <input
                                    className="cn-field__checkradio"
                                    type="checkbox"
                                    name="a-check"
                                    id={header.Id}
                                    checked={isFilter
                                        ? header.IsFiltered
                                        : header.IsVisible}
                                    onChange={() => {
                                        onCheckedOfColumnFilter(tabsData, requestForId, header.Id, (isFilter
                                            ? header.IsFiltered
                                            : header.IsVisible), isFilter, filterName, (isFilter
                                                ? filter.FilterId
                                                : 0));
                                    }}
                                />
                                <span className="cn-field__text noc-filter__list">{header.DisplayName}</span>
                            </label>
                        </li>
                    ))
                    }
                </ul>
                {isFilter
                    ? <button
                        className="cn-btn cn-btn--small cn-btn--primary cn-filter__submit"
                        onClick={() => {
                            filteredDataColumns(tabsData, requestForId, filterName, columnFilters);
                        }}
                    >DONE</button>
                    : ''
                }
            </div>
        );
    }
}

export default ColumnFilterHeader;



// WEBPACK FOOTER //
// ./app/components/column-filter-header.jsx